import React from "react";
import { Avatar } from "@material-ui/core";
import { toImageUrl } from "../../../../../utils/formatHelper";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";

export const initialTableOptions = {
    pageSize: 20,
    pageSizeOptions: [5, 10, 20, 50],
    actionsColumnIndex: -1,
    emptyRowsWhenPaging: false,
    headerStyle: {
        fontSize: 15,
    },
    debounceInterval: 700,
    // have not affect table
    totalData: 0,
    order: "",
    direction: "",
};

export const tableColumns = [
    {
        title: "ID",
        field: "id",
    },
    {
        title: "Image",
        field: "imagePath",
        sorting: false,
        render: rowData => {
            const path = rowData?.imagePath?.slice(0, 5);
            return (
                <Avatar
                    variant="rounded"
                    alt={"imge_pack"}
                    src={
                        rowData?.imagePath
                            ? path !== "https"
                                ? toImageUrl(rowData?.imagePath)
                                : rowData?.imagePath
                            : toAbsoluteUrl("/media/HCH/users/empty_img.png")
                    }
                />
            );
        },
    },
    {
        title: "Name",
        field: "fullname",
    },
    {
        title: "Email",
        field: "email",
    },
    {
        title: "Role",
        field: "Role.roleName",
        render: rowData => <div>{!rowData?.isAdmin ? rowData?.roleName : "Administrator"}</div>,
    },
];

export const initailUserFormValues = {
    fullname: "",
    roleId: "",
    phoneNumber: "",
    email: "",
    username: "",
    password: "",
    images: "",
    isAdmin: false,
};
